import {NgModule} from '@angular/core';

import {ReportRoutingModule} from './report-routing.module';

@NgModule({
  imports: [
    ReportRoutingModule
  ]
})
export class ReportModule {
}
